import {
  clubPremierNumber,
  createValidator,
  dayB,
  lastFourNumbersPhone,
  lastName,
  monthB,
  password,
  yearB,
  yearDate,
} from './validation';

const userProfileLoginValidationFields = {
  clubPremierNumber: [clubPremierNumber],
  password: [password],
  lastName: [lastName],
  phoneN: [lastFourNumbersPhone],
  yearDate: [yearDate],
  dayB: [dayB],
  monthB: [monthB],
  yearB: [yearB],
};

const userProfileLoginValidator = createValidator(userProfileLoginValidationFields);

const userProfileLoginValidation = values => {
  return userProfileLoginValidator(values);
};

export default userProfileLoginValidation;
